import { render, staticRenderFns } from "./MyLocation.vue?vue&type=template&id=6cad957e&scoped=true"
import script from "./MyLocation.vue?vue&type=script&lang=js"
export * from "./MyLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad957e",
  null
  
)

export default component.exports